import { createSelector } from 'reselect';
import { useAppSelector } from '../reducers';
import { isAppAuthSelector } from './AuthSelectors';
export const allPromotionsSelector = ({
  promotions
}) => promotions;
export const allProductsSelector = ({
  abstractedProducts: {
    productMap
  }
}) => productMap;
const _rawProductListSelector = ({
  abstractedProducts: {
    rawProductList
  }
}) => rawProductList;
export const skuMapSelector = ({
  abstractedProducts: {
    skuMap
  }
}) => skuMap;
export const apiNameToProductIdSelector = ({
  abstractedProducts: {
    apiNameToProductId
  }
}) => apiNameToProductId;
const productLineLevelToProductIdSelector = ({
  abstractedProducts: {
    productLineLevelToProductId
  }
}) => productLineLevelToProductId;
export const requiredOnboardingSelector = state => {
  const {
    requiredOnboarding
  } = state;
  return requiredOnboarding;
};
export const productInventorySelector = ({
  productInventory
}) => productInventory;
export const featuresSelector = ({
  features
}) => features;
export const companyDetailsSelector = ({
  companyDetails
}) => companyDetails;
export const productDataSelector = createSelector([allProductsSelector, skuMapSelector, apiNameToProductIdSelector, productLineLevelToProductIdSelector, _rawProductListSelector], (productMap, skuMap, apiNameToProductId, productLineLevelToProductId, rawProductList) => ({
  productMap,
  skuMap,
  apiNameToProductId,
  productLineLevelToProductId,
  rawProductList
}));
export const gatesSelector = state => {
  if (isAppAuthSelector(state)) {
    const {
      auth: {
        gates,
        user: {
          scopes = []
        }
      }
    } = state;
    return [...gates, ...scopes];
  }
  const {
    publicFeatureFlags
  } = state;
  return publicFeatureFlags;
};
export const transformState = createSelector(
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore ignore the error where useSelector is limited to 12 selectors
[productDataSelector, allPromotionsSelector, requiredOnboardingSelector, gatesSelector, featuresSelector, productInventorySelector, companyDetailsSelector], (productData, promotions, requiredOnboarding, gates, features, productInventory, companyDetails) => ({
  productData,
  promotions,
  requiredOnboarding,
  gates,
  features,
  productInventory,
  companyDetails
}));
export const usePricingLibSelector = selector => useAppSelector(state => selector(transformState(state)));